// @flow

import { connect } from 'react-redux';

import { atualizaSelecaoTodos } from '../../../../../../../reducers/lista_documentos/cte';

import SelecaoTodos from '../../common/selecao_todos';

export default connect<*, *, *, *, *, *>(null, { atualizaSelecaoTodos })(SelecaoTodos);